/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Status_LinkedInputs */

const cs_pm_status_linked = /** @type {(inputs: Pm_Status_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Už propojeno`)
};

const en_pm_status_linked = /** @type {(inputs: Pm_Status_LinkedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already linked`)
};

/**
* | output |
* | --- |
* | "Already linked" |
*
* @param {Pm_Status_LinkedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_status_linked = /** @type {((inputs?: Pm_Status_LinkedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Status_LinkedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_status_linked(inputs)
	return cs_pm_status_linked(inputs)
});